<template>
  <div :id="`${source}_bulk_export_modal`">
    <CustomModal
      :visible="visible"
      @update:visible="$emit('update:visible', $event)"
      :title="title"
      width="36vw"
      @close="handleClose"
    >
      <div class="flex flex-col gap-6">
        <span>{{ description }}</span>
        <div id="email" class="form_col">
          <label for="email-input" class="secondary_color text-[13px]"
            >Email ID</label
          >
          <CustomInput
            id="email-input"
            format="text"
            v-model="emailInput"
            placeholder="Enter Email"
            type="primary"
            :is-error="!!emailInputErrorMessage"
            :error-message="emailInputErrorMessage"
            :on-change="() => (emailInputErrorMessage = '')"
          />
          
          <span v-if="selectCount > maxRows" class="text-red-500 text-[13px]">
            Selection exceeds maximum limit of {{ maxRows.toLocaleString() }} rows
          </span>
        </div>
      </div>
      <template #footer>
        <a-button
          class="primary_medium"
          @click="handleExportClick"
          :disabled="selectCount > maxRows"
        >
          Export
        </a-button>
      </template>
    </CustomModal>
  </div>
</template>

<script setup>
import CustomModal from "@/src/components/CustomModal.vue";
import CustomInput from "@/src/components/CustomInput.vue";
import { ref, watch } from "vue";
import { validateEmail } from "@/src/utils/utils.js";

const props = defineProps({
  source: { type: String, required: true },
  visible: { type: Boolean, required: true },
  title: { type: String, required: true },
  description: { type: String, required: true },
  selectCount: { type: Number, required: true },
  maxRows: { type: Number, default: 25000 },
});

const emits = defineEmits(["update:visible", "confirm"]);

const emailInput = ref("");
const emailInputErrorMessage = ref("");

const handleClose = () => {
  emailInput.value = "";
  emailInputErrorMessage.value = "";
};

const handleExportClick = () => {
  
  if (props.selectCount > props.maxRows) {
    emailInputErrorMessage.value =
      `Selection exceeds maximum limit of ${props.maxRows.toLocaleString()} rows`;
    return; // This prevents the API call entirely
  }
  
  if (!emailInput.value?.trim()) {
    emailInputErrorMessage.value = "Please add an Email";
    return;
  }

  if (!validateEmail(emailInput.value)) {
    emailInputErrorMessage.value = "Please enter valid email";
    return;
  }

  emits("confirm", {
    email: emailInput.value.trim(),
  });
};

watch(
  () => props.visible,
  (newVal) => {
    newVal
      ? (emailInput.value = localStorage.getItem("userEmail") || "")
      : handleClose();
  },
  {
    immediate: true,
  },
);
</script>
